import { deleteTracklistBookmark, postTracklistBookmark } from "@api/bookmarks";
import { deleteTrackListLike, postTrackListLike } from "@api/tracklists";
import type { Tracklist } from "@api/tracklists/types";
import { batch } from "solid-js";
import { createStore } from "solid-js/store";

const useControlTracklist = (controlledTracklist: Tracklist) => {
	const [tracklist, setTracklist] = createStore(controlledTracklist);

	const onBookmark = () => {
		const p = tracklist.bookmarked ? deleteTracklistBookmark(tracklist.uuid) : postTracklistBookmark(tracklist.uuid);
		p.then(() => {
			batch(() => {
				setTracklist("bookmark_count", (s) => s + (tracklist.bookmarked ? -1 : 1));
				setTracklist("bookmarked", (s) => !s);
			});
		});
	};

	const onLike = () => {
		const p = tracklist.bookmarked ? deleteTrackListLike(tracklist.uuid) : postTrackListLike(tracklist.uuid);
		p.then(() => {
			batch(() => {
				setTracklist("rating", (s) => s + (tracklist.liked ? -1 : 1));
				setTracklist("liked", (s) => !s);
			});
		});
	};

	const onTrackBookmark = (index: number) => {
		setTracklist("tracks", index, "bookmarked", (s) => !s);
	};
	return { tracklist, onBookmark, onLike, onTrackBookmark };
};
export default useControlTracklist;
